import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/services/data.service';
import { ProjectManagementService } from 'app/services/project-management.service';

@Component({
    selector: 'app-project-evaluation-tab',
    templateUrl: './project-evaluation-tab.component.html',
    styleUrls: ['./project-evaluation-tab.component.scss']
})
export class ProjectEvaluationTabComponent implements OnInit {

    evaluated_data = {
        modified_date: null,
        search_results_score: null,
        claim_chart_score: null,
        search_history_score: null,
        data_coverage: null,
        sum: null,
        x_y_a: null,
        comments: null,
        application_of_search_result: null,
        given_by: null
    };

    selected_project = {};
    evaluationDetailsLoading = false;

    constructor(
        public dataService: DataService,
        private project_management_service: ProjectManagementService,
    ) { }

    ngOnInit() {
        this.projectEvaluation();
    }

    projectEvaluation() {
        if (this.dataService.selected_project !== 0) {
            this.evaluationDetailsLoading = true;
            this.project_management_service.getEvaluation(this.dataService.selected_project, (resp) => {
                if (resp.status) {
                    this.evaluated_data = resp.data
                }
                this.evaluationDetailsLoading = false;
            });
        }
    }
}
